import { useCallback } from "react";

import { PaymentMethod } from "@/lib/gql/__generated__/graphql";

export const useConvertPaymentMethodText = () => {
	/**
	 * 決済方法をテキストへ変換
	 */
	const onConvertPaymentMethodText = useCallback((paymentMethod: PaymentMethod | null) => {
		switch (paymentMethod) {
			case null:
				return "手動入力";
			case PaymentMethod.Credit:
				return "事前決済";
			case PaymentMethod.Local:
				return "現地決済";
			case PaymentMethod.Test:
				return "テスト決済";
			case PaymentMethod.Free:
				return "無料予約";
			default:
				return "不明";
		}
	}, []);

	return {
		onConvertPaymentMethodText,
	};
};
